
// Subscribe to Echo channels
import {WS_HOST} from '../config'
import store from '../vuex/store'

window.io = require('socket.io-client')

import Echo from "laravel-echo"

var wsClient = {
  initialized: false, // Have the channels been subscribed to?
  echo: null,
  userId: null, // Need to store this so we can leave channels after the user has logged out

  // Start up the pusher client and subscribe to all required channels
  init() {
    console.debug('Starting WebSocket Client')
    this.initialized = true
    this.userId = store.state.users.currentUser.id

    this.echo = new Echo({
      broadcaster: 'socket.io',
      host: WS_HOST,
      auth: {
        headers: {
          'Authorization': 'Bearer ' + store.state.accessToken
        }
      }
    })

    this.echo
      .private('clients')
      .listen('.client.updated', (data) => {
        if (data.client) {
          store.commit('SET_CLIENT', data.client)
        }
      })

    this.echo
      .private('projects')
      .listen('.project.updated', (data) => {
        if (data.project) {
          store.commit('SET_PROJECT', data.project)
        }
      })

    this.echo
      .private('tasks')
      .listen('.task.updated', (data) => {
        if (data.task) {
          store.commit('SET_TASK', data.task)
        }
      })

    this.echo
      .private('logs')
      .listen('.log.updated', (data) => {
        if (data.log) {
          store.commit('SET_LOG', data.log)
        }
      })

    this.echo
      .private('users')
      .listen('.user.updated', (data) => {
        if (data.user) {
          store.commit('SET_USER', data.user)
        }
      })

    this.echo
      .private('app-builds')
      .listen('.app-build.updated', (data) => {
        if (data.appBuild) {
          store.commit('SET_APP_BUILD', data.appBuild)
        }
      })

    this.echo
      .private('notifications.' + this.userId)
      .listen('.notification.updated', (data) => {
        if (data.notification) {
          store.commit('SET_NOTIFICATION', data.notification)
        }
      })

    this.echo
    .private('tags')
    .listen('.tag.updated', (data) => {
      if (data.tag) {
        store.commit('SET_TAG', data.tag)
      }
    })
  },

  // Unsubscribe from all channels
  stop() {
    console.debug('Stopping WebSocket Client')
    this.echo.leave('clients')
    this.echo.leave('projects')
    this.echo.leave('tasks')
    this.echo.leave('logs')
    this.echo.leave('users')
    this.echo.leave('app-builds')
    this.echo.leave('notifications.' + this.userId)
    this.echo.leave('tags')

    this.userId = null
    this.echo = null
    this.initialized = false
  }
}

export default wsClient
